import { create } from 'zustand';

interface UserTypesStore {
  search: string;
  debounced: string;
  addOpen: boolean;
  editTarget: unknown | null;
  deleteConfirm: unknown | null;
  deleteError: string | null;
  setSearch: (q: string) => void;
  setDebounced: (q: string) => void;
  setAddOpen: (open: boolean) => void;
  setEditTarget: (t: unknown | null) => void;
  setDeleteConfirm: (t: unknown | null) => void;
  setDeleteError: (e: string | null) => void;
}

export const useUserTypesStore = create<UserTypesStore>((set) => ({
  search: '',
  debounced: '',
  addOpen: false,
  editTarget: null,
  deleteConfirm: null,
  deleteError: null,
  setSearch: (q) => set({ search: q }),
  setDebounced: (q) => set({ debounced: q }),
  setAddOpen: (open) => set({ addOpen: open }),
  setEditTarget: (t) => set({ editTarget: t }),
  setDeleteConfirm: (t) => set({ deleteConfirm: t }),
  setDeleteError: (e) => set({ deleteError: e }),
}));
